// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df03ddc2","239":"b54099ce","453":"5187c867","455":"1aa239d6"}[chunkId] + ".chunk.js";
};